import { render, staticRenderFns } from "./EditRecordingConfigForm.vue?vue&type=template&id=a2638e2a&scoped=true&"
import script from "./EditRecordingConfigForm.vue?vue&type=script&lang=js&"
export * from "./EditRecordingConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./EditRecordingConfigForm.vue?vue&type=style&index=0&id=a2638e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2638e2a",
  null
  
)

export default component.exports